// Module
var code = `<ng-form name="\$ctrl.form">
  <div class="form-column">
    <form-section form-title="'Credentials'">
      <form-section-field field-title="'Username'">
        <input
          type="text"
          ng-model="\$ctrl.agent.username"
          ng-disabled="\$ctrl.agent.id"
          required
          maxlength="32"/>
      </form-section-field>
      <form-section-field field-title="'New password'">
        <password
          model="\$ctrl.agent.password.newPassword"
          ng-required="!\$ctrl.agent.id || \$ctrl.forcedPasswordUpdate"
          complexity-rules="\$ctrl.complexityRules">
        </password>
      </form-section-field>
      <form-section-field field-title="'Retype new password'">
        <input
          name="passwordretype"
          type="password"
          ng-model="\$ctrl.retypedPassword"
          ng-required="\$ctrl.agent.password.newPassword"
          validate-password="{{\$ctrl.agent.password.newPassword}}"/>
      </form-section-field>
      <form-section-field field-title=""
                          ng-if="\$ctrl.form.passwordretype.\$invalid">
        <p ng-if="\$ctrl.form.passwordretype.\$error.validatePassword">Passwords don't match</p>
      </form-section-field>
    </form-section>

    <form-section form-title="'Working hours'">
      <form-section-field field-title="'Working hours'">
        <div class="horizontal">
          <glue-container prepend="'From'">
            <input
              type="time"
              ng-model="\$ctrl.agent.workingHoursFrom"
              ng-required="true"/>
          </glue-container>
          <glue-container prepend="'To'">
            <input
              type="time"
              ng-model="\$ctrl.agent.workingHoursTo"
              ng-required="true"/>
          </glue-container>
        </div>
      </form-section-field>
    </form-section>
  </div>

  <div class="clearfix"></div>
</ng-form>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/agent-banking/details/credentials/agents-credentials.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;